<template>
  <div id="AboutMeCollage1" style="padding-bottom: 70%;">
    <img
      fetchpriority="high"
      style="width: 60%;"
      src="/static/about-me/i1.webp"
    />
    <div>
      <img
        fetchpriority="high"
        style="width: 50%; translate: -3% -5%;"
        src="/static/about-me/i2.webp"
      />
      <img
        fetchpriority="high"
        style="width: 37%; translate: 1% 16%;"
        src="/static/about-me/i3.webp"
      />
    </div>
    <img
      id="FallingSticker1Anchor"
      fetchpriority="high"
      style="width: 65%; translate: 0% 10%"
      src="/static/about-me/i4.webp"
    />
    <StickMe name="12" size="14" left="18" top="6" />
    <StickMe
      name="14"
      size="8"
      left="85"
      top="2.4"
      uk-parallax="x: -30%,200%; y: 30%,-80%"
    />
    <StickMe
      name="15"
      size="12"
      left="95"
      top="8"
      uk-parallax="x: -100%,0%; y: 50%,-80%"
    />
    <StickMe name="13" size="12" left="79" top="18" uk-parallax="y: -100%" />
    <StickMe name="16" size="26" left="81" top="28.5" />
    <StickMe name="2" size="28" left="8" top="28" uk-parallax="x: 50%;" />
    <StickMe name="18" size="20" left="12" top="15" />
    <StickMe name="13" size="12" left="8" top="35" uk-parallax="y: 100%;" />
    <StickMe name="3" size="15" left="57" top="35" uk-parallax="x: 30%;" />
    <StickMe name="3" size="15" left="99" top="43.5" uk-parallax="x: 60%;" />
    <StickMe name="1" size="17" left="54" top="52" uk-parallax="x: 80%;" />
    <StickMe name="20" size="20" left="14" top="63" />
    <StickMe name="23" size="20" left="81" top="69" />
    <StickMe name="17" size="11" left="36" top="77" uk-parallax="x: 50%;" />
    <StickMe name="17" size="11" left="62" top="79" uk-parallax="x: 50%;" />
    <StickMe name="17" size="11" left="52" top="82.5" uk-parallax="x: 50%;" />
    <StickMe
      name="3"
      size="27"
      left="73"
      top="85"
      uk-parallax="x: 110%;"
      style="z-index: 3;"
    />
    <StickMe
      name="22"
      size="22"
      left="28"
      top="82"
      uk-parallax="x: -250%; y: 150%"
    />
    <StickMe name="3" size="25" left="13" top="81.4" uk-parallax="x: 110%;" />
    <StickMe
      name="13"
      size="20"
      left="32"
      top="88"
      uk-parallax="x: 200%; scale: 0.3"
    />
    <StickMe name="3" size="13" left="23" top="87" uk-parallax="x: 50%;" />
    <StickMe
      ref="stickerAnchor"
      name="21"
      size="45"
      left="50"
      top="74"
      style="opacity: 0;"
    />
    <div
      ref="stickerContainer"
      class="sticker"
      :style="{
        opacity: hide ? 0 : 1,
        top: '74%',
        left: '50%',
        width: '45%',
      }"
    >
      <StickMe
        ref="sticker"
        name="21"
        size="100"
        style="translate: 0%;"
        uk-parallax="target: #FallingSticker1Anchor; y: -50%, 0%;"
      />
    </div>
    <StickMe name="17" size="11" left="-5" top="95" uk-parallax="x: 50%;" />
    <StickMe
      name="19"
      size="44"
      left="0"
      top="34"
      uk-parallax="target: #AboutMeCollage1; x: -50%, 1300%;"
    />
  </div>
</template>

<script>
import StickMe from './StickMe.vue'

export default {
  components: {
    StickMe,
  },
  props: {
    hide: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onScroll() {
      let stickerAnchor = this.$refs.stickerAnchor.$el
      let stickerAnchorRect = stickerAnchor.getBoundingClientRect()
      let stickerContainer = this.$refs.stickerContainer

      let startAt = 100

      if (stickerAnchorRect.top > startAt) {
        stickerContainer.style.position = 'absolute'
        stickerContainer.style.top = stickerAnchor.style.top
        stickerContainer.style.left = stickerAnchor.style.left
        stickerContainer.style.translate = stickerAnchor.style.translate
      } else if (stickerAnchorRect.top < startAt) {
        stickerContainer.style.position = 'fixed'
        stickerContainer.style.top = `${startAt}px`
        stickerContainer.style.left = `${stickerAnchorRect.left}px`
        stickerContainer.style.width = `${stickerAnchorRect.width}px`
        stickerContainer.style.height = `${stickerAnchorRect.height}px`
        stickerContainer.style.translate = '0%'
      }
    },
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll, { passive: false })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },
}
</script>



// WEBPACK FOOTER //
// src/components/about-me/AboutMeCollage1.vue